module.exports = __webpack_public_path__ + "static/media/20210212_215826_335_IMG_2203.f40aace7.jpg";